export default "__VITE_ASSET__DRSBTBdp__"